import React, { useState } from 'react';
import { func, string, bool } from 'prop-types';
import { validate as validator } from 'ui-validator';
import { PLTextField } from '../../../../shared_modules/local-propulsion/components';
import { Page } from '../../components';
import validations from './dob-validations';
import { heapTrackErrors } from '../../../../shared_modules/baui-heap-tracking';
import { truncateLongName } from '../../utils/util';
import SecurityNotice from '../../components/SecurityNotice';

const DOB = ({ monthBirth, dayBirth, yearBirth, isSecondary, name, saveValues, nextLocation, previousLocation }) => {
  const [model, setModel] = useState({
    monthBirth,
    dayBirth,
    yearBirth,
  });
  const [validationErrors, setValidationErrors] = useState({});

  const getTitleHeader = () => {
    if (isSecondary) {
      const borrowerName = truncateLongName(name);
      return {
        title: `${borrowerName}, when’s your birthday?`,
        header: `This helps us verify your identity and create your joint offer.`,
      };
    }

    return {
      title: 'When’s your birthday?',
      header: 'Sharing your birthday helps us verify your identity and create your offer.',
    };
  };

  const handleInputChange = e => {
    const { rawValue } = e.target;
    const { month = '', day = '', year = '' } = rawValue;
    setModel({
      monthBirth: month,
      dayBirth: day,
      yearBirth: year.trim(),
    });
  };

  const handleBlur = () => setValidationErrors(validator(model, validations));

  const submit = e => {
    if (e) e.preventDefault();
    const errors = validator(model, validations);
    if (!Object.keys(errors).length) {
      const type = isSecondary ? 'secondary' : '';
      saveValues({ dob: model }, type);
      nextLocation();
    } else {
      setValidationErrors(errors);
      heapTrackErrors(errors);
    }
  };

  const defaultValue = `${model.monthBirth} / ${model.dayBirth} / ${model.yearBirth}`;

  return (
    <Page
      title={getTitleHeader().title}
      header={getTitleHeader().header}
      name="dob"
      goBack={previousLocation}
      submitHandler={submit}
    >
      <div className="form__input">
        <PLTextField
          name="dob"
          type="tel"
          component="Date"
          onBlur={handleBlur}
          defaultValue={defaultValue}
          onChange={handleInputChange}
          label="Date of Birth"
          errors={validationErrors.monthBirth}
          autoComplete="bday-month"
          autoFocus={!model.monthBirth}
        />
      </div>
      <SecurityNotice text="We’re serious about security, so we encrypt every page of our website with Secure Socket Layer (SSL) to protect your data." />
    </Page>
  );
};

DOB.propTypes = {
  saveValues: func.isRequired,
  previousLocation: func.isRequired,
  nextLocation: func.isRequired,
  isSecondary: bool.isRequired,
  dayBirth: string.isRequired,
  monthBirth: string.isRequired,
  yearBirth: string.isRequired,
  name: string.isRequired,
};

export default DOB;

